import React from "react";

const About = () => {
  return (
    <div>
      <h1>About</h1>
      <p>
        Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.
        Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Donec
        sollicitudin molestie malesuada. Cras ultricies ligula sed magna dictum
        porta. Vivamus magna justo, lacinia eget consectetur sed, convallis at
        tellus. Quisque velit nisi, pretium ut lacinia in, elementum id enim.
        Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada
        feugiat. Vivamus magna justo, lacinia eget consectetur sed, convallis at
        tellus. Vivamus suscipit tortor eget felis porttitor volutpat. Vivamus
        magna justo, lacinia eget consectetur sed, convallis at tellus. Mauris
        blandit aliquet elit, eget tincidunt nibh pulvinar a. Sed porttitor
        lectus nibh. Vestibulum ante ipsum primis in faucibus orci luctus et
        ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet
        aliquam vel, ullamcorper sit amet ligula. Mauris blandit aliquet elit,
        eget tincidunt nibh pulvinar a. Vestibulum ante ipsum primis in faucibus
        orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor
        sit amet aliquam vel, ullamcorper sit amet ligula. Donec sollicitudin
        molestie malesuada. Donec rutrum congue leo eget malesuada. Curabitur
        non nulla sit amet nisl tempus convallis quis ac lectus.
      </p>
    </div>
  );
};

export default About;
